import Box from "@mui/material/Box";
import styles from "./StatusChangeTimeLine.module.scss";
import { PreOrderData, SessionData, StatusChange, StatusChangeTimeLineEntity } from "../../common/Interfaces";
import { useEffect, useState } from "react";
import { getStatusChanges } from "../../common/requests/StatusChangesRequests";
import AppLoading from "../../components/common/loading/AppLoading";
import StatusChangeTimeLineItem from "./StatusChangeTimeLineItem";

type Props = {
    preOrder: PreOrderData;
    session: SessionData;
}

export default function StatusChangeTimeLine ({preOrder, session}: Props){
    const [statusChanges, setStatusChanges] = useState<StatusChange[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const getStatusChangesFromEvent = async () => {
        try{
            const result = await getStatusChanges(session.token ?? '', session.sessionData.ManagementId, preOrder.Event?.Id ?? 0);
            
            if (result.data?.length > 0){
                setStatusChanges(result.data);
            }
        }
        finally{
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getStatusChangesFromEvent();
    }, []);

    const generateTimeLine = () => {
        if (preOrder.CurrentStatus){
            return <StatusChangeTimeLineItem
                statusChange={{
                    statusChange: {
                        Id: 0,
                        InitialStatus: preOrder.CurrentStatus,
                        FinalStatus: preOrder.CurrentStatus,
                        ChangeDate: preOrder.ModificationDate ?? '',
                        IsManual: 1,
                        CreatedBy: preOrder.StatusChangedBy ?? '',
                        Observation: preOrder.StatusObservation,
                    },
                    isInitialStatusChange: true,
                    event: {
                        CreationDate: preOrder.StatusDate ?? '',
                        CreatedBy: preOrder.StatusChangedBy ?? ''
                    },
                    isLiteralDate: true,
                }}
            />
        }

        if ((preOrder && preOrder.Event) && (!statusChanges || statusChanges.length === 0)){
            return <StatusChangeTimeLineItem
                statusChange={{
                    statusChange: {
                        Id: 0,
                        InitialStatus: preOrder.Event!.CurrentStatus,
                        FinalStatus: preOrder.Event!.CurrentStatus,
                        ChangeDate: preOrder.Event!.CreationDate ?? '',
                        IsManual: 1,
                        CreatedBy: preOrder.Event!.CreatedBy,
                        Observation: preOrder.Event!.Observation,
                    },
                    isInitialStatusChange: true,
                    event: preOrder.Event!
                }}
            />
        }

        const items: StatusChangeTimeLineEntity[] = [];
        items.push(
            {
                statusChange: {
                    ...statusChanges[0],
                    Observation: preOrder.Event!.Observation,
                },
                isInitialStatusChange: true,
                event: preOrder.Event!
            }
        );

        if (statusChanges.length > 0){
            statusChanges.map((statusChangeItem) => items.push({
                statusChange: statusChangeItem,
                isInitialStatusChange: false,
                event: preOrder.Event!
            }));
        }

        return items.map((statusChange) => 
        <StatusChangeTimeLineItem
            statusChange={statusChange}
        />)
    }

    return (<Box className={styles.container}>
        {
            isLoading ? (<AppLoading/>) 
            : (
                generateTimeLine()
            )
        }
    </Box>)
}